<template>
  <v-app>
    <textchat-widget />
  </v-app>
</template>

<style lang="scss">
html, body, .v-application {
  height: 100%;
  width: 100%;
  font-size: 14px;
}
.messageBox {
  position: relative;
  .caption {
    margin-bottom: 0.25em;
    padding: 0;
  }
  .message {
    position: relative;
    display: inline-block;
    width: auto;
    margin-right: auto;
    padding: 1em 1.5em;
    margin-bottom: 1em;
    border-radius: 2em;
    overflow: hidden;
    box-shadow: // vuetify box style
      0 3px 1px -2px rgba(0,0,0,0.2),
      0 2px 2px 0px rgba(0,0,0,0.14),
      0 1px 5px 0px rgba(0,0,0,0.12);
    .bgrd {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: #888;
      opacity: 0.08;
    }
  }
  &.customer {
    text-align: right;
    .message {
      border-top-right-radius: 0;
    }
  }
  &.business {
    text-align: left;
    .message {
      border-top-left-radius: 0;
    }
  }
}
</style>

<script>
import TextchatWidget from '@/components/TextchatWidget'

export default {
  components: {
    TextchatWidget
  }
}
</script>
